module.exports = __webpack_public_path__ + "img/2.d47219f2.png";